export default "/backend/static/media/modify_organization2.ee0c7d66.png";